<template src="./html/Datatable.html"></template>

<script>
	import swal from 'sweetalert2'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'

	import Create from './Create'
	import Edit from './Edit'
	import Values from './Values'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['isAuth', 'user'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,

			'create': Create,
			'edit': Edit,
			'values': Values,
			'loading': VueElementLoading,
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/products/attribute/lists/datatable',
					loading: true,
					moreParams: {
						filter: {},
					},
					page: 100,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: 'id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: '__slot:name',
							title: 'Nombre',
							sortField: 'name',
						},
						{
							name: '__slot:field',
							title: 'Tipo',
						},
						{
							name: 'created_at',
							title: 'Fecha',
							sortField: 'created_at',
							callback: function(value) {
								return (value) ? moment(value).format('DD/MM/YY') : null
							},
						},
						{
							name: '__slot:actions',
							title: '',
						},
					],
				},
			}
		},
		methods: {
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			filterReset() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			destroy(item) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/products/attribute/lists/' + item.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type)
							}).catch(function(response) {
								console.log(response)
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type)
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
			openEdit(item) {
				this.$refs.edit.open(item)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productAttributeLists/views/Datatable.vue